import {Pipe, PipeTransform} from '@angular/core';
import {Dropdown} from '@emma-labs/shared/typescript';

@Pipe({name: 'emFilterDropdownOptions'})
export class FilterDropdownOptionsPipe implements PipeTransform {
  transform(options: Dropdown<any>[], valueToFilterOut: any) {
    return options.filter((option) => option.value !== valueToFilterOut);
  }
}
